import values from 'lodash/values';

import createSort from '../../../../shared/table/create-sort.js';

const defaultInitialState = {
	columns: {
		date: {
			index: 'date',
			title: 'Date',
			direction: 'desc'
		},
		admin_id: {
			index: 'admin_id',
			title: 'Admin',
			direction: 'desc'
		},
		status: {
			index: 'status',
			title: 'Status',
			direction: 'desc'
		},
		affiliate_id: {
			index: 'affiliate_id',
			title: 'Affiliate',
			className: 'modify--border',
			direction: 'desc'
		},
		amount: {
			index: 'amount',
			title: 'Amount',
			className: 'amount',
			direction: 'desc'
		},
		payment_system_id: {
			index: 'payment_system_id',
			title: 'Payment System',
			className: 'payout-system',
			direction: 'desc'
		}
	},
	sortByColumn: {
		index: 'date',
		title: 'date',
		direction: 'desc'
	}
};

const createTable = ({
	namespace,
	stateNodeName,
	configureSort
}) => {

	const sort = createSort(namespace, stateNodeName, {
		type: configureSort.type,
		resolverSortFn: configureSort.resolverSortFn
	});

	// action types
	const SHOW_MORE_ROWS = `${namespace}/table-show-more-rows`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = Object.assign({
		showMoreRows: () => ({
			type: SHOW_MORE_ROWS
		})
	}, sort.actions);

	// reducers
	const reducers = Object.assign({}, sort.reducers);

	// selectors
	const selectors = {
		getTable: state => {
			const { table, data } = state[namespace];
			const rows = data ? sort.order(data, table.sortByColumn) : [];

			return {
				headers: values(table.columns),
				rows,
				sortedColumn: table.sortByColumn,
				rowsNumber: table.rowsNumber,
				totalRows: rows.length
			};
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createTable;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-log/payments/components/table/index.js